import { axios } from '@lib/axios';

import {
    RecurringSubscriptionListQuery,
    RecurringSubscriptionCreationForm,
    RecurringSubscriptionBillingAmountCreationForm,
    RecurringSubscriptionResponse,
    RecurringSubscriptionData,
    RecurringSubscriptionAmountCalculationResponse,
    RecurringSubscriptionBillingAmountCalculationQuery,
    RecurringSubscriptionBillingAmountDeletionForm,
    RecurringSubscriptionCreationResponse,
    RecurringSubscriptionParticipantsUpdateForm,
    RecurringSubscriptionTrialDurationResponse,
} from 'chaika-frontend-types/frontend-cms';
import { RecurringSubscriptionBillingAmountResponse } from 'chaika-types/src/finance/recurring-subscription/responses/RecurringSubscriptionBillingAmountResponse';
import { RecurringSubscriptionBillingAmountListQuery } from 'chaika-types';

const BASE_URL = '/api/recurring-subscription';

export class RecurringSubscriptionApi {
    public static async create(
        params: RecurringSubscriptionCreationForm,
    ): Promise<RecurringSubscriptionCreationResponse> {
        const res = await axios.post<RecurringSubscriptionCreationResponse>(BASE_URL, params);

        return res.data;
    }

    public static async find(params: RecurringSubscriptionListQuery): Promise<RecurringSubscriptionResponse> {
        const resp = await axios.get<RecurringSubscriptionResponse>(BASE_URL, { params });

        return resp.data;
    }

    public static async get(id: string): Promise<RecurringSubscriptionData> {
        const resp = await axios.get<RecurringSubscriptionData>(`${BASE_URL}/${id}`);

        return resp.data;
    }

    public static async updateParticipants(id: string, params: RecurringSubscriptionParticipantsUpdateForm) {
        await axios.put(`${BASE_URL}/${id}`, params);
    }

    public static async getBillingAmount(
        params: RecurringSubscriptionBillingAmountListQuery,
    ): Promise<RecurringSubscriptionBillingAmountResponse> {
        const res = await axios.get<RecurringSubscriptionBillingAmountResponse>(`${BASE_URL}/billing-amount`, {
            params,
        });

        return res.data;
    }

    public static async calculateBillingAmount(
        params: RecurringSubscriptionBillingAmountCalculationQuery,
    ): Promise<RecurringSubscriptionAmountCalculationResponse> {
        const res = await axios.post<RecurringSubscriptionAmountCalculationResponse>(
            `${BASE_URL}/calculation`,
            undefined,
            {
                params,
            },
        );

        return res.data;
    }

    public static async getTrialDuration(): Promise<RecurringSubscriptionTrialDurationResponse> {
        const res = await axios.get<RecurringSubscriptionTrialDurationResponse>(`${BASE_URL}/trial-duration`);

        return res.data;
    }

    public static async updateBillingAmount(params: RecurringSubscriptionBillingAmountCreationForm): Promise<void> {
        await axios.post(`${BASE_URL}/billing-amount`, params);
    }

    public static async deleteBillingAmount(params: RecurringSubscriptionBillingAmountDeletionForm): Promise<void> {
        await axios.delete(`${BASE_URL}/billing-amount`, {
            data: params,
        });
    }
}
